import { cva, type VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/**
 * §19.2 — Rozet.
 *
 * Tam yuvarlak (hap) değil, hafif köşeli. Hap biçimi etiketi "süs" gibi
 * gösteriyor; veri tablosunda rozet bir DEĞER taşıyor (durum, kanal, sayı) ve
 * hizalı bir dikdörtgen o değeri komşu hücrelerle aynı ızgaraya oturtuyor.
 *
 * İçeriden bir tel (`ring`) kenar veriyor: yumuşak zeminler açık temada
 * birbirine yakın; tel olmadan rozetin nerede bittiği belirsiz kalıyor.
 */
const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-[5px] px-1.5 py-0.5 text-[0.6875rem] font-medium leading-4 ring-1 ring-inset',
  {
    variants: {
      tone: {
        neutral: 'bg-bg-sunken text-fg-muted ring-border',
        accent: 'bg-accent-soft text-accent ring-accent/15',
        success: 'bg-success-soft text-success ring-success/15',
        warning: 'bg-warning-soft text-warning ring-warning/15',
        danger: 'bg-danger-soft text-danger ring-danger/15',
        info: 'bg-info-soft text-info ring-info/15',
      },
    },
    defaultVariants: { tone: 'neutral' },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}
